<main>
  <div class="content">
    <label class="title">{{'addUser.createUser' | transloco }}</label>
    <div class="register">

      <div class="input-data">
        <label>{{'addUser.inputName' | transloco }}</label>
        <input [(ngModel)]="user.name" matInput appBlurOnEnter>
      </div>

      <div class="input-data">
        <label>{{'addUser.createPassword' | transloco }}</label>
        <input [(ngModel)]="user.password" matInput type="password" appBlurOnEnter>
      </div>
      <button (click)="onSave()" class="save-button">{{'addUser.addUser' | transloco }}</button>
    </div>
  </div>
    
    <hr class="vertical-line" />
    <div class="content">
      <div class="flex-container">
        <label class="title">{{'addUser.createUserAD' | transloco }}</label>
        <button class="close" (click)="onClose()">
        </button>
      </div>
      
      <div class="register-AD">
        <div class="input-data">
          <label>{{'addUser.inputNameAD' | transloco }}</label>
          <input [(ngModel)]="nameAD" matInput appBlurOnEnter>
        </div>
        <button (click)="onSaveAD()">{{'addUser.addUserAD' | transloco }}</button>
      </div>
    </div>
</main>
